import { motion } from "framer-motion";

export const EASE = [0.16, 1, 0.3, 1];
export const EASE_IO = [0.76, 0, 0.24, 1];

export const RevealLines = ({ lines, as: Tag = "h1", className = "", delay = 0, stagger = 0.11, inView = false, lineClass = () => "" }) => {
  const trigger = inView
    ? { initial: "hide", whileInView: "show", viewport: { once: true, amount: 0.15 } }
    : { initial: "hide", animate: "show" };
  return (
    <Tag className={className}>
      <motion.span className="block" {...trigger}>
        {lines.map((line, i) => (
          <span key={i} className="block overflow-hidden pb-[0.08em] -mb-[0.08em]">
            <motion.span
              className={`block will-change-transform ${lineClass(i)}`}
              variants={{ hide: { y: "112%", rotate: 2.5 }, show: { y: "0%", rotate: 0 } }}
              transition={{ duration: 1.1, ease: EASE, delay: delay + i * stagger }}
            >
              {line}
            </motion.span>
          </span>
        ))}
      </motion.span>
    </Tag>
  );
};

export const FadeUp = ({ children, delay = 0, className = "", y = 28, as = "div", ...rest }) => {
  const M = motion[as];
  return (
    <M
      className={className}
      initial={{ opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, amount: 0.15 }}
      transition={{ duration: 0.9, ease: EASE, delay }}
      {...rest}
    >
      {children}
    </M>
  );
};

export const SectionLabel = ({ n, children, className = "" }) => (
  <div className={`flex items-center gap-3 font-mono text-[11px] uppercase tracking-[0.25em] text-skaris-sky ${className}`}>
    <span className="h-px w-8 bg-skaris-sky/60" />
    {n && <span className="text-cream/50">{n}</span>}
    <span>{children}</span>
  </div>
);
